// extracted by mini-css-extract-plugin
export default {"ellipsis":"mxwTEnzHVus51qfPAf9p","wrapper":"c9o5_njj3fZ4SF_SbLsF","amount":"CXdnvt25d63h0W49oBIw","spin":"aL4kSfV9bbx4VGV5Of9T"};